import axios from 'axios';

import { BASE_HOST_URL } from '../config';

let baseURL = BASE_HOST_URL;
if (process.env.NODE_ENV === 'development') {
  baseURL = 'http://localhost:3005';
}

export function getClients() {
  return axios.get(`${baseURL}/api/v1/clients`);
}

export function getClientsByNIF(nif) {
  return axios.get(`${baseURL}/api/v1/clients/nif/${nif}`);
}



// WEBPACK FOOTER //
// ./src/services/clients.js